import { Box, Typography } from "@mui/material";
import React from "react";

const ContactCard = ({ icon, link, title }) => {
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {icon}
        <a href={link}>
          <Typography
            sx={{
              lineHeight: "20px",
              fontWeight: "400",
              fontSize: "18px",
              marginTop: "-2px",
            }}
          >
            {title}
          </Typography>
        </a>
      </Box>
    </div>
  );
};

export default ContactCard;
